<div class="container points-summary-bar d-flex justify-content-between d-lg-none my-3 align-items-center">
  <!-- Back Button -->
  <div class="back-btn bg-primary" [routerLink]="[backButtonLink]">
    <span class="material-symbols-outlined text-white"> arrow_back_ios_new </span>
  </div>

  <!-- Points Bar -->
  <fgb-points-summary></fgb-points-summary>
</div>
